import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  VStack,
  useToast
} from '@chakra-ui/react';
import { BASE_URL } from '../../../Globalapi/Globalapi';

const EditFeeModal = ({ isOpen, onClose, feeData,refreshData}) => {
  const [formData, setFormData] = useState(feeData || {});
  const toast = useToast();

  useEffect(() => {
    if (feeData) {
      setFormData(feeData);
    }
  }, [feeData]);
  console.log(feeData);
  

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission and API call
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Call the provided API to update the fee data
    try {
      const response = await fetch(`${BASE_URL}/admin/Fees/fees_view/admin_edit.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: formData.fee_id,  // Assuming feeData has an `id`
          start_date: formData.start_date,
          due_date: formData.due_date,
          fine_amount: formData.fine_amount,
          total_amount: formData.total_amount,
          discount: formData.discount,
        }),
      });
      const p={
        id: formData.fee_id,  // Assuming feeData has an `id`
        start_date: formData.start_date,
        due_date: formData.due_date,
        fine_amount: formData.fine_amount,
        total_amount: formData.total_amount,
        discount: formData.discount,
      }

      console.log('====================================');
      console.log(p);
      console.log('====================================');

      const result = await response.json();
      console.log(result);
      
      refreshData()
      if (result.success) {
        toast({
          title: 'Fee Updated',
          description: 'The fee information has been successfully updated.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
        onClose(); // Close the modal after success
      } else {
        throw new Error(result.message || 'Failed to update fee');
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Fee Information</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch" as="form" onSubmit={handleSubmit}>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                name="start_date"
                value={formData.start_date || ''}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Due Date</FormLabel>
              <Input
                type="date"
                name="due_date"
                value={formData.due_date || ''}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Total Amount</FormLabel>
              <Input
                type="number"
                name="total_amount"
                value={formData.total_amount || ''}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Fine Amount</FormLabel>
              <Input
                type="number"
                name="fine_amount"
                value={formData.fine_amount || ''}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Discount</FormLabel>
              <Input
                type="number"
                name="discount"
                value={formData.discount || ''}
                onChange={handleChange}
              />
            </FormControl>
            <Button type="submit" colorScheme="blue" width="full">
              Update Fee
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EditFeeModal;
